// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".atom-image-slider{position:relative}.atom-image-slider .lazy-loader-wrapper{height:100%;left:0;position:absolute;top:0;width:100%}.atom-image-slider .image-relative{position:relative}.atom-image-slider .description{background:rgba(0,0,0,.6);bottom:0;color:#fff;font-size:18px;font-weight:400;left:0;padding:15px;position:absolute;right:0;z-index:9}@media(max-width:600px){.atom-image-slider .description{display:none}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
